// extracted by mini-css-extract-plugin
export var numberInputContainer = "_7j-0";
export var startPickingButton = "_7j-1";